<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row">
    <v-card
        @click="$store.commit('dialog_is_order',{toggle:true,index:currentIndex})"
    >
      <v-row>
        <v-col class="ml-4">
          {{ order.code}}
        </v-col>
        <v-col class="col-2">
          status
        </v-col>
        <v-col class="col-2 text-right mr-4">
          {{ number_format(order.total_net)}}
        </v-col>
      </v-row>
    </v-card>
  </div>

</template>
<style lang="scss" scoped>

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Order} from '../../models/Order'

  import Helper from '../../services/Helper.js'


  @Component({
    components: {},
  })
  export default class OrderRowInCustomer extends Vue {
    @Prop() order: Order
    @Prop() currentIndex: number

    number_format(number) {
      return Helper.number_format(Math.round(number))
    }

  }

</script>
